import React from "react"
import Chart, { ChartDataSets } from "chart.js"
import { ChartHelper, ChartDataConfig, ChartBaseProps } from "./chartsHelper";
export interface LineChartProps extends ChartBaseProps {
    data: ChartDataConfig;
    filled?: boolean;
}

export class LineChart extends React.Component<LineChartProps>{
    chartComponent: HTMLCanvasElement;
    chart: Chart;

    componentDidMount() {
        this.chart = new Chart(this.chartComponent, {
            type: "line",
            data: {
                labels: this.props.data.labels,
                datasets: this.buildDatasets(this.props),
            },
            options: {
                responsive: !this.props.disableResponsive,
                maintainAspectRatio: this.props.maintainAspectRatio != null ? this.props.maintainAspectRatio : true,
                title: {
                    display: this.props.title ? true : false,
                    text: this.props.title,
                    position: this.props.title && "top" || undefined,
                },
                legend: {
                    display: !this.props.hideLegend,
                    position: this.props.legendPosition || "top",
                },
                scales: {
                    xAxes: [{
                        display: !this.props.hideXAxes
                    }],
                    yAxes: [{
                        display: !this.props.hideYAxes
                    }]
                }
            }
        });
    }

    private buildDatasets(props: LineChartProps) {
        const colorScheme = ChartHelper.getColorScheme(this.props.colorscheme || 1);
        return props.data.datasets.map((x, i) => {
            console.log(x);
            return {
                data: x.values,
                label: x.description,
                backgroundColor: x.backgroundColor || colorScheme[i],
                borderColor: x.borderColor || colorScheme[i],
                fill: this.props.filled && "origin" || false,
            } as ChartDataSets;
        });
    }

    refreshData(props: LineChartProps) {
        this.chart.data.labels = [...props.data.labels];
        this.chart.data.datasets = [...this.buildDatasets(props)];
    }

    removeData() {
        this.chart.data.labels!.pop();
        this.chart.data.datasets!.forEach(dataset =>
            dataset.data!.pop()
        );
    }

    componentDidUpdate(prevProps: LineChartProps) {
        this.refreshData(prevProps);
        this.chart.update();
    }

    render() {
        return (
            <canvas
                ref={input => this.chartComponent = input!}>
            </canvas>
        );
    }
}